<div class="white-box main-black mt-4 p-4 border-radius">
	<div class="row mb-4">
		<div class="col">
			<h4>
				{{'fleet_reports.monthly_quarterly_charger_usage_charts' | translate}}
			</h4>
		</div>
	</div>

	<div class="row mb-4">
		<!-- years list -->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="yearList" bindLabel="label" bindValue="id" placeholder="{{'site.year' | translate}}" name="year" [(ngModel)]="selectedYear" (ngModelChange)="selectYear()" [clearable]="false">
			</ng-select>
		</div>

		<!-- Monthly or Quarterly drop-down -->
		<div class="col-sm-6 col-md-2 d-inline-flex" *ngIf="!isAllYearsSelected()">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="periodTypes" bindLabel="label" bindValue="id" placeholder="{{'perf_analytic.period' | translate}}" name="period" [(ngModel)]="selectedPeriodType" (ngModelChange)="changePeriodType()" [clearable]="false">
			</ng-select>
		</div>

		<!-- charts toggle -->
		<div class="col-sm-6 col-md-2 d-inline-flex">
			<ng-select [searchable]="false" class="mr-auto w-100" [items]="chartsList" bindLabel="label" bindValue="id" placeholder="{{'g.chart' | translate}}" name="chart" [(ngModel)]="selectedCharts" [clearable]="false">
			</ng-select>
		</div>

	<div class="d-inline-flex ml-auto" *ngIf="!noData">
			<button  class="btn fa fa-print fa-lg" printTitle="{{'fleet_reports.monthly_quarterly_charger_usage_charts' | translate}}" [useExistingCss]="true" printSectionId="monthly_quarterly_charger_usage_charts" ngxPrint title="{{'g.print' | translate}}"></button>
			<button class="fa fa-upload btn" title="{{'g.export_to_csv' | translate}}" (click)="exportDataToCsv()"></button>
		</div>
	</div>

	<!-- charts -->
	<div id="monthly_quarterly_charger_usage_charts" *ngIf="!noData">
		<app-print-filters title="fleet_reports.monthly_quarterly_charger_usage_charts" [filters]="printFilters"></app-print-filters>
		<div class="row" *ngIf="['charge_hours', 'all'].includes(selectedCharts)">
			<div class="col">
				<h5>{{'fleet_reports.total_charge_hours' | translate}}</h5>
			</div>
			<sct-charts
				*ngIf="chartsData.total_charge_hours[selectedYear]"
				id="charge_hours"
				[data]="chartsData.total_charge_hours[selectedYear]"
				[columnNames]="timeColumnNames"
				[options]="timeChartConfig"
				[haveZoom]="isChartHaveZoom()"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['charge_ah', 'all'].includes(selectedCharts)">
			<div class="col">
				<h5>{{'fleet_reports.total_charge_ah' | translate}}</h5>
			</div>
			<sct-charts
				*ngIf="chartsData.total_charge_ah[selectedYear]"
				id="charge_ah"
				[data]="chartsData.total_charge_ah[selectedYear]"
				[columnNames]="['Time', 'fleet_reports.total_charge_ah' | translate]"
				[options]="chartObject.config"
				[haveZoom]="isChartHaveZoom()"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="getMaxKw && ['max_kw', 'all'].includes(selectedCharts)">
			<div class="col">
				<h5>{{'fleet_reports.max_kw' | translate}} <app-help-tooltip [field]="'chargLinkDevice.max_kw_chart'"></app-help-tooltip></h5>
			</div>
			<sct-charts
				*ngIf="chartsData.total_max_kw[selectedYear]"
				id="inuse_kwh"
				[data]="chartsData.total_max_kw[selectedYear]"
				[columnNames]="chartObject.columnNames"
				[options]="chartObject.config"
				[haveZoom]="isChartHaveZoom()"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
		<div class="row" *ngIf="['charge_kwh', 'all'].includes(selectedCharts)">
			<div class="col">
				<h5>{{'fleet_reports.total_charge_kwh' | translate}}</h5>
			</div>
			<sct-charts
				*ngIf="chartsData.total_charge_kwh[selectedYear]"
				id="charge_kwh"
				[data]="chartsData.total_charge_kwh[selectedYear]"
				[columnNames]="['Time', 'fleet_reports.total_charge_kwh' | translate]"
				[options]="chartObject.config"
				[haveZoom]="isChartHaveZoom()"
				[type]="'ColumnChart'"
				[height]="500"
			></sct-charts>
		</div>
	</div>

	<div class="card-body" *ngIf="noData">
		<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
	</div>
</div>

